import SingleDateInput from 'pureUi/SingleDateInput';
import styled from 'styled-components';

export const StyledSingleDateInput = styled(SingleDateInput)`
  .pseudoSelect {
    height: 35px;
    background-color: #fbfbfa;
  }
`;